import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { translate } from '~l10n/client';
import activity from 'activity';
import rootStudentController from 'root-student-controller';
import _ from 'underscore';
import user from 'user';

import dots from 'Dots';
import StudentNameModel from 'StudentNameModel';
import view from 'StudentNameView';

import { ErrorView } from '../../../shared/error/ErrorView';

const popup = require('../../../../shared/components/popup/PopupController');

let model = null;

function StudentNameController() {}

StudentNameController.prototype = _.extend(
  Object.create(Object.getPrototypeOf(rootStudentController)),
  {
    doName: function () {
      if (!controller.shouldDoName()) {
        controller.doNextRoute();
      } else {
        model = new StudentNameModel();
        controller.renderView();
      }
    },

    renderView: function () {
      let comp = React.createElement(view, {
        controller: controller,
        model: model,
      });
      ReactDOM.render(
        <ErrorView>{comp}</ErrorView>,
        document.getElementById('main-content')
      );
    },

    nameChanged: function (name) {
      model.name = name;
      model.error = false;
      controller.renderView();
    },

    doneClicked: function () {
      if (model.settingName) {
        return;
      } else {
        model.settingName = true;
      }

      dots.start('submit-name-button');

      model.name = _.escape(model.name.trim());

      if (model.isValidName()) {
        user.set('user_input_name', model.name);

        activity.setStudentName(
          model.name,
          () => {
            controller.doNextRoute();
          },
          (error) => {
            console.error('Error setting student name', error);
            // Unset user input so user won't get stuck in weird state on error
            user.unset('user_input_name');
            model.settingName = false;

            popup.render({
              title: translate('Unknown Error'),
              message: translate(
                'Your latest changes were not saved. Please check your connection and try again.'
              ),
              isModal: true,
            });
          }
        );
      } else {
        model.error = true;
        dots.stop();
        model.settingName = false;
        controller.renderView();
      }
    },
  }
);

StudentNameController.prototype.constructor = StudentNameController;
let controller = new StudentNameController();

module.exports = controller;
